import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SkipLoaderService {
  private readonly skipLoaderSubject = new BehaviorSubject<boolean>(false);
  public skipLoader$: Observable<boolean> = this.skipLoaderSubject.asObservable();

  setSkipLoader(value: boolean): void {
    this.skipLoaderSubject.next(value);
  }

  getSkipLoader(): boolean {
    return this.skipLoaderSubject.value;
  }
}

